"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasValidTracingSearchTypes = exports.TRACING_SEARCH_TYPE_REQUIRED_MESSAGE = exports.TracingSearchType = void 0;
const zod_1 = require("zod");
exports.TracingSearchType = zod_1.z.enum(["id", "content", "input", "output"]);
exports.TRACING_SEARCH_TYPE_REQUIRED_MESSAGE = "At least one search type is required when searching tracing data";
const hasValidTracingSearchTypes = ({ searchQuery, searchType, }) => !searchQuery || !searchType || searchType.length > 0;
exports.hasValidTracingSearchTypes = hasValidTracingSearchTypes;
